export const PathTypes = {
  CLEAR_PATH: 'PATH__CLEAR_PATH',
  APPEND_POINT: 'PATH__APPEND_POINT',
  REMOVE_POINT: 'PATH__REMOVE_POINT',
  MOVE_POINT: 'PATH__MOVE_POINT',
  SET_ACTIVE_POINT: 'PATH__SET_ACTIVE_POINT',
}

export const appendPoint = (coordinate: any) => (dispatch: any) =>
  dispatch({
    type: PathTypes.APPEND_POINT,
    payload: coordinate,
  })

export const removePoint = (index: any) => (dispatch: any) =>
  dispatch({
    type: PathTypes.REMOVE_POINT,
    payload: index,
  })

export const movePoint = (move: any) => (dispatch: any) =>
  dispatch({
    type: PathTypes.MOVE_POINT,
    payload: move,
  })

export const clearPath = (path: any) => (dispatch: any) =>
  dispatch({
    type: PathTypes.CLEAR_PATH,
    payload: path,
  })
